export default {
    data: () => ({
        translations: {
            title: {
                el: "Τιμολόγηση",
                en: "Invoicing",
                it: "Fattura"
            },
            name: {
                el: "Νομικό Όνομα",
                en: "Legal Name",
                it: "Nome legale"
            },
            taxId: {
                el: "ΑΦΜ",
                en: "Tax File Number",
                it: "Numero del file fiscale"
            },
            address: {
                el: "Έδρα",
                en: "Business Address",
                it: "Sede centrale"
            },
            profession: {
                el: "Επάγγελμα",
                en: "Profession",
                it: "Occupazione"
            },
            jurisdiction: {
                el: "ΔΟΥ",
                en: "Tax Area",
                it: "Ufficio fiscale"
            },
            invoice: {
                el: "Φορολογία",
                en: "Invoice From",
                it: "Tassazione"
            }
        }
    })
};
